/**
 * CookieBot Class
 */
export class CookieBot {

	#embededBlocks;

	/**
	 * CookieBot Construct.
	 *
	 * @class
	 */
	constructor() {

		this.#embededBlocks = document.querySelectorAll( '.wp-block-embed' );
		this.init();

	}

	/**
	 * Initializes embed handling.
	 *
	 * @return {void}
	 */
	init = () => {


		this.manageEmbedsState();

		window.addEventListener( 'CookiebotOnAccept', this.manageEmbedsState );
		window.addEventListener( 'CookiebotOnDecline', this.manageEmbedsState );



	}

	/**
	 * Syncs all dynamic embed wrappers with the current marketing-consent state.
	 *
	 * @return {void}
	 */
	manageEmbedsState = () => {

		const hasConsent =  typeof window.Cookiebot !== 'undefined' && window.Cookiebot.consent.marketing;
		const wrappers = document.querySelectorAll( '.dynamic-embed-wrapper' );

		if ( !wrappers.length ) {

			return;

		}

		wrappers.forEach( wrapper => {

			const template = wrapper.querySelector( '.embeded-content-template' );
			const placeholder = wrapper.querySelector( '.embed-placeholder' );
			const activeContent = wrapper.querySelector( '.active-embed-content' );

			if ( hasConsent ) {

				if( placeholder ) {

					placeholder.style.display = 'none';

				}

				if ( !activeContent && template ) {

					const content = template.content.cloneNode( true );
					const activeDiv = document.createElement( 'div' );
					activeDiv.classList.add( 'active-embed-content' );
					activeDiv.appendChild( content );
					wrapper.appendChild( activeDiv );

				}

			} else {

				if( placeholder ) {

					placeholder.style.display = 'block';

				}

				if ( activeContent ) {

					activeContent.remove();

				}

			}

		} );

	}


	/**
	 * Replaces all `.embeded-content-template` instances with their content,
	 * but only when marketing consent is granted.
	 *
	 * @param {boolean} hasConsent Whether the user has granted marketing consent.
	 * @return {void}
	 */
	showEmbededContent = ( hasConsent ) => {

		if ( !hasConsent ) {

			return;

		}

		const templates = document.querySelectorAll( '.embeded-content-template' );

		if ( templates.length < 1 ) {

			return;

		}

		templates.forEach( template => {

			const content = template.content.cloneNode( true );
			template.replaceWith( content );

		} );

	}


	/**
	 * Hides all tracked embedded blocks by setting `display: none`.
	 *
	 * Expects `this.#embededBlocks` to be an iterable collection of elements.
	 *
	 * @return {void}
	 */
	hideEmbededContent = () => {

		if ( this.#embededBlocks.length < 1 ) {

			return;

		}

		this.#embededBlocks.forEach( block => {

			block.style.display = 'none';

		} );

	}

}
